<template>
  <v-card>
    <v-card-title>
      <h2 style="text-align: center; font-size: 1rem">Pilih Bulan & Tahun Laporan Neraca Saldo</h2>
    </v-card-title>
    <br />
    <v-row justify="center">
      <v-date-picker v-model="periode" type="month" />
      <br />
    </v-row>
    <v-card-actions>
      <v-spacer />
      <v-btn color="error" variant="text" @click="onclose"> Batal </v-btn>
      <v-btn
        color="primary"
        variant="text"
        @click="
          () => {
            onclose();
            generateNeracaSaldo();
          }
        "
      >
        Generate Laporan
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ModalNeracaSaldo',
  data() {
    return {
      periode: '',
    };
  },
  mounted() {
    let period = this.$getSelectedMonthYear();
    this.periode = period.dateTime;
  },
  props: {
    onclose: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    generateNeracaSaldo() {
      this.$router.push('/laporan/gl/neracaSaldo?periode=' + this.periode);
    },
  },
};
</script>
